import React, { createContext, useState } from 'react';

export const CopyrightContext = createContext()

export const YearContext = ({children})=>{

    // const Year = 
    const year = new Date().getFullYear(); 

    return (
        <CopyrightContext.Provider value={year}>
                {children}
        </CopyrightContext.Provider>
    )
}
    